// RxJS
import { delay, distinctUntilChanged } from 'rxjs/operators';
// CRUD
import { QueryResultsModel, BaseDataSource } from '../../_base/crud';
// State
import { Store, select } from '@ngrx/store';
import { AppState } from '../../reducers';
import {selectProductGroupsInitWaitingMessage, selectProductGroupsInStore, selectProductGroupsPageLoading} from '../_selectors/product-group.selectors';
// Selectors

export class ProductGroupsDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
		super();
		this.loading$ = this.store.pipe(
			select(selectProductGroupsPageLoading)
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectProductGroupsInitWaitingMessage)
		);

		this.store.pipe(
			select(selectProductGroupsInStore)
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.totalCount);
			this.entitySubject.next(response.items);
		});
	}
}
